import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FeatureFlag } from '@app/enums/feature-flag.enum';
import { FeatureGuard } from '@app/guards';
import { NavigationGuard } from '@app/guards/navigation.guard';
import { PermissionGuard } from '@app/guards/permission.guard';
import { RoutesWithOptions } from '@app/interfaces';
import { FeatureFlagResolver } from '@app/resolvers/FeatureFlag.resolver';
import { EmployeesImportView, IntegrationsImportView } from '@import/views';
import { Employee } from '@models/employee/employee.model';

const routes: RoutesWithOptions = [
    { path: '', pathMatch: 'full', redirectTo: 'employees' },
    {
        path: 'employees',
        component: EmployeesImportView,
        canDeactivate: [NavigationGuard],
        canActivate: [PermissionGuard],
        resolve: {
            flags: FeatureFlagResolver,
        },
        data: {
            permission: Employee.importPermission,
        },
    },
    {
        path: 'integrations',
        component: IntegrationsImportView,
        canDeactivate: [NavigationGuard],
        canActivate: [FeatureGuard],
        data: {
            feature: {
                flags: [FeatureFlag.employeeImportIntegrations],
            },
        },
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class ImportRouterModule {}
